
const Message = {
    Warning : {
        Delete: "Are You sure to delete this item?"
    },
    Success : {
        Save : "Saved Successfully"
    }
};

export default Message;